var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var Checkmark = function (_a) {
    var onClick = _a.onClick, className = _a.className;
    return (_jsx("svg", __assign({ width: '10', height: '8', viewBox: '0 0 10 8', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', onClick: onClick, className: className }, { children: _jsx("path", { d: 'M1 3.78672L3.8 6.40005L9 0.800049', stroke: 'white', strokeWidth: '1.5', strokeLinecap: 'round', strokeLinejoin: 'round' }) })));
};
export { Checkmark };
//# sourceMappingURL=Checkmark.js.map